export default {
  exportReport: '/admin/facebook_ads/export', //谷歌报告导出
  reportData: '/admin/facebook_ads/report', //消耗数据
  pageList: '/admin/facebook_ads/page_list', //服务单主页
  audienceReport: '/admin/facebook_ads/audience_report', //受众报告
  audienceReportCountry: '/admin/facebook_ads/audience_report/country', //受众报告国家地区
  audienceReportExport: '/admin/facebook_ads/audience_report/export', //受众报告国家地区
}
